import * as React from 'react';
import { Skeleton } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import SummaryContainer from './SummaryContainer.js';

const SummaryLoader = ()=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(SummaryContainer, null, /*#__PURE__*/ React.createElement(Skeleton, {
        height: 60,
        width: 200,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": getLabel('common.loadingText')
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "200",
        height: "16px",
        rx: "4",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "180",
        height: "16px",
        rx: "4",
        fill: "currentColor",
        y: "32"
    })));
};

export { SummaryLoader as default };
//# sourceMappingURL=SummaryLoader.js.map
